"use client";

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import type { FaqItem } from "@/lib/content/types";
import { cn } from "@/lib/utils";

export default function FaqAccordion({
  items: faqItems,
}: {
  items: FaqItem[];
}) {
  return (
    <Accordion className="divide-y divide-line rounded-2xl border border-line bg-card px-5 md:px-6">
      {faqItems.map((item, index) => (
        <AccordionItem key={item.question} value={`faq-${index}`}>
          <AccordionTrigger className="py-5 text-base font-medium text-foreground hover:no-underline md:text-[17px]">
            {item.question}
          </AccordionTrigger>
          <AccordionContent
            className={cn(
              "pb-5 text-[15px] leading-7 text-foreground",
              "[&_ul]:my-3 [&_ul]:list-disc [&_ul]:space-y-2 [&_ul]:ps-5",
              "[&_li]:ps-1",
            )}
          >
            <div dangerouslySetInnerHTML={{ __html: item.answer }} />
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
